import {
	request
} from '@/common/request.js'
import api from '@/common/api.js'
import env from '@/common/env.js'
import {
	contractUrl,
} from '@/utils/share/utils.js'
import store from '@/store/index'

/**
 * 判断是否安装插件
 * @param {Object} name 插件名称
 */
export const isInstallAddons = function(name) {
	let config = store.state.mallConfig
	let arr = env.addonsList ? env.addonsList : []
	let addonsList = config.valid_addons ? config.valid_addons : arr
	let i = addonsList.findIndex(it => it.trim().toLowerCase() == name.trim().toLowerCase())
	return i > -1 ? true : false
}

export const getObjValue = function(target = {}, keys = [], def) {
	let obj = {}
	let value = null
	for (var key in target) {
		obj[key] = target[key]
	}
	try {
		value = keys.reduce((prev, key) => {
			return prev[key]
		}, target)
	} catch (error) {
		value = def
	}
	return value || def
}

// 保留2位小数
export const keepDecimal = function(value) {
	return (value * 1).toFixed(2)
}

/**
 * 获取code
 */
export const getWxCode = function() {
	return new Promise((resolve, reject) => {
		uni.login({
			provider: 'weixin',
			scopes: 'auth_user',
			success: (res) => {
				resolve(res.code)
			},
			fail: (err) => {
				reject(err)
			}
		})
	})
}
//清除搜索缓存search_cach_close
export const search_cach_close = function() {
	uni.setStorageSync('history_word', '');
}
// 保存搜索缓存
export const history = function(history_word,keyword) {
	if(!keyword) return false;
	let key = {};
	key['sum'] = 1;
	key['word'] = keyword; //console.log(this.history_word,66);
	if(history_word.length>0){
		let is_no = 2;
		history_word.forEach((item,index)=>{
			if(item.word == keyword){
				history_word[index].sum += 1;
				is_no = 1;
			}
		})
		if(is_no ==2){
			history_word.push(key);
		}
	}else{
		history_word.push(key);
	}
	history_word.sort(function(a,b){
		return b.sum - a.sum;
	})
	//console.log(this.history_word,444);
	uni.setStorageSync('history_word', JSON.stringify(history_word));
}

/**
 * 获取系统信息
 */
export const getSystemInfo = function() {
	let data = ''
	uni.getSystemInfo({
		success: (res) => {
			// console.log(res, 'ok')
			data = res
		}
	})
	return data;
}

/**
 * 自定义导航的头部高度
 */
export const navBarHeight = function() {
	let height = 0
	let statusBarHeight = uni.getSystemInfoSync().statusBarHeight;





	height = statusBarHeight + 44

	return height
}

/**
 * author hp
 * msg 判断是否为微信浏览器 
 */
export const isWeChat = function() {

	var ua = window.navigator.userAgent.toLowerCase();
	if (ua.match(/micromessenger/i) == 'micromessenger') {
		return true;
	} else {
		return false;
	}

}

/**
 * 判断是否为深颜色
 * @param {String} color 颜色 rgb
 */
export const isDarkColor = function(color) {
	var RgbValue = color.replace("rgb(", "").replace(")", "");
	var RgbValueArry = RgbValue.split(",");
	var $grayLevel = RgbValueArry[0] * 0.299 + RgbValueArry[1] * 0.587 + RgbValueArry[2] * 0.114;
	if ($grayLevel >= 192) {
		return false
	} else {
		return true
	}
}

// 十六进制颜色转Rgba
export const colorRgbaFun = function(color, opacity = 1) {
	// 16进制颜色值的正则
	var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	color = color.toLowerCase();
	if (reg.test(color)) {
		// 如果只有三位的值，需变成六位，如：#fff => #ffffff
		if (color.length === 4) {
			var colorNew = "#";
			for (var i = 1; i < 4; i += 1) {
				colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
			}
			color = colorNew;
		}
		// 处理六位的颜色值，转为RGB
		var colorChange = [];
		for (var i = 1; i < 7; i += 2) {
			colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
		}
		return "RGBA(" + colorChange.join(",") + "," + opacity + ")";
	} else {
		return color;
	}
}

/**
 * 返回上一页携带参数
 * name: 上一个接收的字段
 * params: 参数内容
 * num: 返回上几页，默认一页
 */
export const goNavigateBack = function(name, params, num = 1) {
	let pages = getCurrentPages();
	let nowPage = pages[pages.length - 1] // 当前页
	let prePage = pages[pages.length - 2] // 上一页
	prePage.$vm[name] = params
	uni.navigateBack({
		delta: num
	})
}

/**
 * 大于1w的数据处理
 * @params {String | Number} val
 */
export const numSystemVal = function(val, n = 2) {
	if (val * 1 < 10000) {
		// val = (val * 1).toFixed(n);
		val = val * 1
	} else {
		if ((val * 1) % 10000 == 0) {
			val = parseInt((val * 1) / 10000) + '万'
		} else {
			val = parseInt((val * 1) / 10000) + '万+'
		}
	}
	return val
}

/**
 * 获取省市区
 * res: Obj
 * res.address：省市区字符串
 * res.name： 详细地址
 */
export const getAddrInfo = function(res) {
	let regex = /^(北京市|天津市|重庆市|上海市|香港特别行政区|澳门特别行政区)/
	let REGION_PROVINCE = []
	let addressBean = {
		REGION_PROVINCE: null,
		REGION_COUNTRY: null,
		REGION_CITY: null,
		ADDRESS: null,
	}
	// 方法
	function regexAddressBean(address, addressBean) {
		regex = /^(.*?[市]|.*?地区|.*?特别行政区)(.*?[市区县])(.*?)$/g
		
		let addxress = regex.exec(address)
		addressBean.REGION_CITY = addxress[1] //市
		addressBean.REGION_COUNTRY = addxress[2] //区
		addressBean.ADDRESS = addxress[3] + res.name //详细地址
	}
	if (!(REGION_PROVINCE = regex.exec(res.address))) {
		regex = /^(.*?(省|自治区))(.*?)$/
		addressBean.REGION_PROVINCE = regex.exec(res.address)[1] //省
		regexAddressBean(regex.exec(res.address)[3], addressBean)
	}else{
		regex = /^(.*?(市))(.*?)$/
		addressBean.REGION_PROVINCE = regex.exec(res.address)[1] //省
		res.address =regex.exec(res.address)[1] +''+ res.address
		regexAddressBean(regex.exec(res.address)[3], addressBean)
	}
	return addressBean
}

/**
 * 返回方法
 */
export const navBack = function() {
	let routes = getCurrentPages();
	if (routes.length == 1) {
		uni.redirectTo({
			url: '/pages/index/index'
		})
	} else {
		uni.navigateBack();
	}
}

export const globalSet = function(str, val = '重新申请') {
	if (uni.getStorageSync('mall_config')) {
		if (str == 'textCol') { //红色字&红按钮
			return JSON.parse(uni.getStorageSync('mall_config')).global_color.global_text_color;
		} else if (str == 'imgUrl') {
			return JSON.parse(uni.getStorageSync('mall_config')).top_pic_url;
		} else if (str == 'couponImg') { //购物券背景图
			return JSON.parse(uni.getStorageSync('mall_config')).global_color.coupon_pic_url;
		} else if (str == 'navBg') { //tabBar背景色
			return JSON.parse(uni.getStorageSync('mall_config')).navbar.top_background_color;
		} else if (str == 'navCol') { //tabBar颜色
			return JSON.parse(uni.getStorageSync('mall_config')).navbar.top_text_color;
		} else if (str == 'btnCol') {
			var global_text_color = JSON.parse(uni.getStorageSync('mall_config')).global_color.global_text_color;
			return [{
				text: "取消",
				plain: true,
				col: global_text_color,
			}, {
				text: val,
				plain: false,
				col: global_text_color,
			}];
		}
	}

}

export const getUrlInfo = function(params) {
	let value = "";
	let appid = "";
	//console.info(params);
	switch (params.open_type) {
		case 'applet':
			value = params.app_path
			appid = params.appid
			break;
		case 'web':
			value = params.link
			break;
		case 'call':
			value = params.telphone
			break;
		default:
			value = params.route
	}

	return {
		value,
		appid,
	}
}

/**
 * 页面跳转
 * @param {String} type 跳转类型
 * @param {Object} value 值
 */
export const pageJump = function(value, type, index) {
	let appid = "";
	let titleName = ""; //标题名
	if (typeof value == 'object') {
		let params = value.params ? value.params : value;
		let paramsInfo = getUrlInfo(params);
		titleName = value.titleName || '';
		value = paramsInfo.value
		appid = paramsInfo.appid;
		type = type ? type : params.open_type;
		value = type == 'call' ? value : contractUrl(value, {"title": titleName})
	}
	//console.info(value, type);
	if (type == 'web') {

		window.location.href = value







	} else if (type == 'call') {
		uni.makePhoneCall({
			phoneNumber: value,
			success: (res) => {
				console.log('打电话回调成功！')
			}
		});
	} else if (type == 'applet') {

			this.$http.toast('暂不支持跳转小程序')














	} else if (type == "redirect") {
		uni.redirectTo({
			url: matchUrl(value)
		})
	} else {
		// if(!value) return;
		uni.navigateTo({
			url: matchUrl(value)
		})
	}
}

export const matchUrl = function(url) {
	var reg = new RegExp(/^\//)
	if (!reg.test(url)) {
		return '/' + url
	}
	return url
}

let count = 1;
export const get_is_share_mandatory_login = function() {
	let state = -1;
	let data = uni.getStorageSync('mall_config');
	if (data) {
		try {
			let config = JSON.parse(data)
			state = config.mall_setting.setting.is_share_mandatory_login || 0
		} catch (e) {
			state = 0
		}
	}
	return state
}

export const isPidToLogin = function() {
	if (count > 5) {
		uni.clearStorageSync()
		return
	} // 清理全部缓存
	let routes = getCurrentPages() // 获取当前打开过的页面路由数组
	let filterRoute = ["pages/public/login"] // 白名单
	let is_share_mandatory_login = get_is_share_mandatory_login()
	if (!routes.length && is_share_mandatory_login === -1) { // 防止栈溢出 -- 需要限制调用次数
		// 解决异步 -- 请求未加载完成的
		setTimeout(() => {
			isPidToLogin()
		}, 100)
		return false
	} else if (is_share_mandatory_login == 0) { // 没有开启强制
		return false
	}
	let curParam = routes[routes.length - 1].options //获取路由参数
	let route = routes[routes.length - 1].route
	let pid = curParam.pid || uni.getStorageSync("pid") || 0
	let token = uni.getStorageSync("token")

	if (filterRoute.some(url => url === route)) {
		return false
	}
	if (pid && !token) {
		uni.navigateTo({
			url: "/pages/public/login",
		})
	}
}
/**
 * 在需要强制登录地方退出时调用 - login页面卸载调用
 * 部分用户会点返回 - 根据返回是否token-pid-强制登录 - 去处理对应事件
 * @param {number}  tiemr  
 */
export function forceLogin(tiemr = 1000) {
	// 延迟调用，体验好
	setTimeout(() => {
		count++
		isPidToLogin()
	}, tiemr)
}

function add0(val) {
	return val < 10 ? '0' + val : val;
}

/**
 * @description 远程地址转化为base64格式
 * @param {string | array} url 
 */
export function imageToBase64(url) {
	const params = {}
	if (Array.isArray(url)) {
		url.forEach(item => {
			params[item.key] = item.value
		})
	} else if (typeof url === "string") {
		params[0] = url
	}
	return new Promise(resolve => {
		transformImageBase(params).then(res => {
			resolve(res)
		})
	})
}
export function capsuleinfo(){
	let capsule_height = {height:30,height_no_border:28,height_border:34,top:3,margin_top:6,margin_top_no_border:8};









	return capsule_height;
}
function transformImageBase(data) {
	return request({
		url: api.default.getImgBase64,
		method: 'POST',
		header: {
			contentType: 'application/x-www-form-urlencoded'
		},
		showLoading: true,
		data: {
			form: JSON.stringify(data)
		}
	})
}
/**
 * @description 读取对象中得图片 并且转化为对象形式
 * @param { array } data 
 * @param { string } getImageKey 读取图片得属性
 */
export function handleKey(data, getImageKey = "url") {
	const result = []
	for (let key in data) {
		const item = data[key]
		if (item[getImageKey]) {
			result.push({
				key,
				value: item[getImageKey]
			})
		}
	}
	return result
}
/**
 * @description 赋值回去对象
 * @param { object} data base64响应对象
 * @param { array } target 海报目标数组
 */
export function reverseHandleKey(data, target, getImageKey = "url") {
	const result = target
	for (let key in data) {
		const url = data[key]
		for (let targetKey in target) {
			if (targetKey === key) {
				target[targetKey][getImageKey] = url
			}
		}
	}
	return result
}
export function base64ToUrl(arr, target) {
	const result = target
	const proArr = []
	for (let key in data) {
		const url = data[key]
		proArr.push(send_code(url, key))
	}
	return Promise.all(proArr).then(data => {
		console.log(data, "data")
		// return false
		// for (let key in data) {
		// 	const url = data[key]
		// 	for (let targetKey in target) {
		// 		if (targetKey === key) {
		// 			target[targetKey][getImageKey] = 1
		// 		}
		// 	}
		// }
	})
}

function send_code(code, key) {
	const fs = wx.getFileSystemManager();
	const times = new Date().getTime();
	const codeimg = wx.env.USER_DATA_PATH + '/' + times + '.png';
	return new Promise(resolve => {
		//将base64图片写入
		fs.writeFile({
			filePath: codeimg,
			data: code.slice(22),
			encoding: 'base64',
			success: () => {
				//写入成功了的话，新的图片路径就能用了
				resolve({
					[key]: codeimg
				});
			}
		});
	})
}

export function deepClone(target) {
	// 定义一个变量
	let result;
	// 如果当前需要深拷贝的是一个对象的话
	if (typeof target === 'object') {
		// 如果是一个数组的话
		if (Array.isArray(target)) {
			result = []; // 将result赋值为一个数组，并且执行遍历
			for (let i in target) {
				// 递归克隆数组中的每一项
				result.push(deepClone(target[i]))
			}
			// 判断如果当前的值是null的话；直接赋值为null
		} else if (target === null) {
			result = null;
			// 判断如果当前的值是一个RegExp对象的话，直接赋值    
		} else if (target.constructor === RegExp) {
			result = target;
		} else {
			// 否则是普通对象，直接for in循环，递归赋值对象的所有值
			result = {};
			for (let i in target) {
				result[i] = deepClone(target[i]);
			}
		}
		// 如果不是对象的话，就是基本数据类型，那么直接赋值
	} else {
		result = target;
	}
	// 返回最终结果
	return result;
}

// 计算头部导航的高度
export function getNavBarHeight() {
	let statusBar = 0
	let customBar = 0
	let obj = {}
	uni.getSystemInfo({
		success: function(e) {
			statusBar = e.statusBarHeight

			if (e.platform == 'android') {
				customBar = e.statusBarHeight + 48
			} else {
				customBar = e.statusBarHeight + 44
			}


















			customBar = 44

			obj = {
				statusBar,
				customBar
			}

		}
	})
	return obj
}

// 判断是否iphoneX
export function isIphoneX() {
	let flag = false
	uni.getSystemInfo({
		success: (res) => {
			console.log(res)
			let modelmes = res.model;
			if (modelmes.search('iPhone X') != -1 || modelmes.search('iPhone 12') != -1) {
				flag = true
			}

		}
	})
	return flag;
}
/* 
	判断是否为JSON字符串
 */
export const isJSON = function(str) {
    if (typeof str == 'string') {
        try {
            var obj=JSON.parse(str);
            if(typeof obj == 'object' && obj ){
                return true;
            }else{
                return false;
            }
        } catch(e) {
            return false;
        }
    }
}

// 颜色渐变

export const colorGradient = function(bg_color) {
    let arr = bg_color.split("");
	if(arr[1] == parseInt(arr[1])){
		if(arr[1]==arr[2] && arr[1]==arr[3] && arr[1]==arr[4] && arr[1]==arr[5] && arr[1]==arr[6]){
			if(arr[1]>=3){
				arr[1] = arr[1] -3;
				arr[2] = arr[2] -3;
				arr[3] = arr[3] -3;
				arr[4] = arr[4] -3;
				arr[5] = arr[5] -3;
				arr[6] = arr[6] -3;
			}else{
				arr[1] = parseInt(arr[1]) + 3;
				arr[2] = parseInt(arr[2]) +3;
				arr[3] = parseInt(arr[3]) +3;
				arr[4] = parseInt(arr[4]) +3;
				arr[5] = parseInt(arr[5]) +3;
				arr[6] = parseInt(arr[6]) +3;
			}
		}else if(arr[1]>3){
			arr[1] = arr[1] -3;
		}else{
			arr[1] = parseInt(arr[1]) + 3;
		}
	}
    
    var str = arr.join('');
	return str;
}
